export default __webpack_public_path__ + "static/media/results.92e8b3cd.svg";